import moment from 'moment'
import { createSelector } from 'reselect'
import { ASSESS_UI_STATES, OFFERING_PLANS } from '../../../../../../constants'
import {
  DI_NOTIFICATION,
  GLOBAL_NOTIFICATION,
  HOME_NOTIFICATION,
  INDIVIDUALS_NOTIFICATION
} from '../../scenes/OfferingPlanAssess/constants'

export const getOrganizations = (state) => state.get('engagement').orgs || {}

export const getOrganizationsCompany = createSelector([getOrganizations], (data) =>
  data.get('company')
)

export const getOrganizationsLoaded = createSelector([getOrganizations], (data) =>
  data.get('loaded')
)

export const getGeneratingKeyLoader = createSelector([getOrganizations], (data) =>
  data.get('isGeneratingKey')
)

// This is for Assess. Determ ine whether or not to show a Component, based on the following flags from darkly.
export const isOfferingPlanAssess = createSelector([getOrganizations], (data) => {
  const { plan } = data?.get('company') || {}
  return plan === OFFERING_PLANS.ASSESS
})

export const getOfferingState = createSelector([getOrganizations], (data) => {
  const { plan_state } = data?.get('company') || {}
  return plan_state
})

export const getOfferingPlan = createSelector([getOrganizations], (data) => {
  const { plan } = data?.get('company') || {}
  return plan
})

export const showStatusOnHomepage = createSelector([getOrganizations], (data) => {
  const STATES_TO_SHOW = [
    ASSESS_UI_STATES.INGESTING,
    ASSESS_UI_STATES.PREVIEW,
    ASSESS_UI_STATES.ASSESSED
  ]

  const { plan_state, plan } = data?.get('company') || {}
  return plan === OFFERING_PLANS.ASSESS && STATES_TO_SHOW.includes(plan_state)
})

export const isVisionVisible = (plan, plan_state) => {
  const PLANS_TO_SHOW = [
    OFFERING_PLANS.MONITOR,
    OFFERING_PLANS.PROTECT,
    OFFERING_PLANS.INTELLIGENCE
  ]
  return (
    PLANS_TO_SHOW.includes(plan) ||
    plan_state === ASSESS_UI_STATES.PREVIEW ||
    plan_state === ASSESS_UI_STATES.ASSESSED
  )
}

export const showUiVision = createSelector([getOrganizations], (data) => {
  const { plan_state, plan } = data?.get('company') || {}
  // If this is true, show the component, false, hide it.
  return isVisionVisible(plan, plan_state)
})

export const blockActionsIfNotIntegration = createSelector([getOrganizations], (data) => {
  const { plan, plan_state } = data?.get('company') || {}
  // returns true if not in Integration state
  return plan === OFFERING_PLANS.ASSESS && plan_state !== ASSESS_UI_STATES.INTEGRATION
})

export const recommended_notification_DI = createSelector([getOrganizations], (data) => {
  const { plan, plan_state } = data?.get('company') || {}
  if (plan === OFFERING_PLANS.ASSESS) {
    return DI_NOTIFICATION[plan_state] || {}
  }
  return {}
})

export const showPreviewNotification = createSelector([getOrganizations], (data) => {
  const { plan, plan_state } = data?.get('company') || {}
  return plan === OFFERING_PLANS.ASSESS && plan_state === ASSESS_UI_STATES.PREVIEW
})

export const recommended_notification_Home = createSelector([getOrganizations], (data) => {
  const { plan, plan_state } = data?.get('company') || {}
  if (plan === OFFERING_PLANS.ASSESS) {
    return HOME_NOTIFICATION[plan_state] || {}
  }
  return {}
})

export const recommended_notification_Individuals = createSelector([getOrganizations], (data) => {
  const { plan, plan_state } = data?.get('company') || {}
  if (plan === OFFERING_PLANS.ASSESS) {
    return INDIVIDUALS_NOTIFICATION[plan_state] || {}
  }
  return {}
})

export const getUpgradeNotificationData = createSelector([getOrganizations], (data) => {
  const { plan, plan_state, plan_state_expiration_date } = data.get('company') || {}
  const currentDate = moment(moment().format('YYYY-MM-DD'))
  const expiryDate = moment(plan_state_expiration_date)
  const diffDays = expiryDate.diff(currentDate, 'days') + 1
  return {
    remainingDays: diffDays,
    showNotification:
      plan === OFFERING_PLANS.ASSESS && plan_state === ASSESS_UI_STATES.ASSESSED && diffDays <= 30,
    ...GLOBAL_NOTIFICATION[plan_state]
  }
})

export const hideManagerDashboardPlan = createSelector([getOrganizations], (data) => {
  const { plan } = data?.get('company') || {}
  const hideMDPlans = [OFFERING_PLANS.ASSESS, OFFERING_PLANS.MONITOR]
  return hideMDPlans.includes(plan)
})
